export const ScreenSize = {
  data() {
    return {
      screen: {
        widthSize: window.outerWidth > 2000 ? Math.round((window.outerWidth * 50.9) / 100) : Math.round((window.outerWidth * 87.9) / 100),
        heightSize: Math.round((window.outerHeight * 55) / 100)
      }
    };
  },
  methods: {
    getSizeWindow() {
      this.screen.widthSize = Math.round((window.innerWidth * 87.9) / 100);
    },
    getHeigthWindow() {
      this.screen.heightSize = Math.round((window.outerHeight * 55) / 100);
    },
    updateModalWidth() {
      this.getSizeWindow();
      this.getHeigthWindow();
    }
  },
  mounted() {
    window.addEventListener('resize', this.updateModalWidth);
  },
  destroyed() {
    window.removeEventListener('resize', this.updateModalWidth);
  }
};
